import { jsx } from 'react/jsx-runtime';

/** ![alignCenterIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNMjEgNkgzTTE3IDEySDdNMTkgMThINSIvPjwvc3ZnPg==) */
const alignCenterIcon = /*#__PURE__*/jsx("path", {
  d: "M21 6H3M17 12H7M19 18H5"
});

export { alignCenterIcon };
